export const SINGLE_MAIL_DATA = {
  invoice_upload_link: `http://localhost:3000/hotel_booking/upload?ref=${"tessToken"}`,
  tmc_logo: "/tmc_logo_text.png",
  client_logo: "/client_logo_text.png",
  subject: "⏰ GST Details for generating invoice",
  acknowledge_mail_url: `https://stage-apiplatform.finkraftai.com/api/webhook/sendgrid/email/ack/${"tessToken"}`,
  upload_invoice_url: `https://hotel.finkraftai.com/hotel_booking/upload?ref=${"tessToken"}`,
  booking_activity: "🎉 Congratulation, you have booking for stay",
  entity: {
    name: "Client Entity Name",
    gstin: "XXAAAXXXXXAXXX",
    address: "Client Entity Address",
  },
  hotel_details: {
    hotel_name: "Hotel Name",
  },
  booking_details: {
    confirmation_number: "XXXXXXXXXX",
  },
  travelinfo: {
    travelers: [],
    contact_persons: "Contact Person",

    travelers_all_string: "",
    hotel: [],
    checkin_date: "01/07/2024",
    booking_date: "08/07/2024	",
    checkout_date: "12/07/2024",
  },
};

export const hotelBookingActivityType = {
  PENDING: " 🎉 Congratulation, you have booking for stay ",
  BOOKING: " Hey!, Your guest has arrived at your hotel  ",
  CHECKIN: " Hurry Up!!, Your guest is about to check-out in next 5 hour ",
  CHECKOUT_1: " Hurry Up!!, Your guest is about to check-out in next 2 hours ",
  CHECKOUT_2: "You are late!!, Your guest has checked out already ",
};
